
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {TakipEntity} from "@/entity/TakipEntity";
import {BankaHesabiSahibiLabel} from "@/enum/BankaHesabiSahibi";

import TakipTalebiGenerator from "@/classes/evrak/TakipTalebi/TakipTalebiGenerator";
import FormWrapper from "@/components/FormWrapper.vue";
import Evrak from "@/classes/evrak/Evrak";
import {AlacakKalemiAlani} from "@/enum/AlacakKalemiAlani";
import KapakHesabi from "@/classes/evrak/KapakHesabi/KapakHesabi";
import KapakHesabiCalculator from "@/classes/evrak/KapakHesabi/KapakHesabiCalculator";
import {TakipDurumuLabel, TakipDurumu} from "@/enum/TakipDurumu";
import {HarcTuru} from "@/enum/HarcTuru";
import {ParaBirimi} from "@/enum/ParaBirimi";
import {TahsilatTuru} from "@/enum/TahsilatTuru";

@Component({
  components: {FormWrapper},
})
export default class OdemeTaahhuduTaslak extends Vue {
  @Prop() takip!: TakipEntity;
  @Prop() isKartNoVisible!: boolean;
  @Prop() vekaletSuretHarc!:boolean

  kapakHesabi: KapakHesabi = new KapakHesabi();
  ttEvrak: Evrak = new Evrak();
  bankaHesabiSahibiLabel = BankaHesabiSahibiLabel;
  alacakKalemiAlani = AlacakKalemiAlani;
  takipDurumu = TakipDurumuLabel;
  harcTuru = HarcTuru
  odemeTaksitDetaylari:any = []
  isLoadingEvrakData: boolean = false;
  isInternalUpdate: boolean = false;
  ParaBirimi = ParaBirimi
  TahsilatTuru = TahsilatTuru

  hesapAyar = JSON.parse(this.takip.taksit_hesap_ayar as unknown as string)

  headers = [
    {text: 'Taksit No', value: 'index'},
    {text: 'Tarih', value: 'tarih'},
    {text: 'Gün Sayısı', value: 'faiz_isleyen_gun'},
    {text: 'Faiz İşletilecek Tutar', value: 'faiz_isletilecek_tutar'},
    {text: 'İşleyecek Faiz', value: 'isleyen_faiz'},
    {text: 'Toplam Faiz', value: 'toplam_faiz'},
    {text: 'Toplam Borç', value: 'kalan_borc'},
    {text: 'Taksit Miktarı', value: 'tutar'},
    {text: 'Kalan', value: 'kalan_ana_para'},
  ]

  async handleTaksitler(){
    const takipId = this.takip?.id || this.$route.params.id;
    if (takipId) {
      try {
        const response = await this.$http.get('/api/v1/takip/' + takipId + '/taksit');
        this.odemeTaksitDetaylari = response.data;
      } catch (error) {
        console.error('Taksit verileri yüklenirken hata oluştu:', error);
      }
    }
  }
  get toplamFaiz(){
    let toplam:number = 0.00
    this.odemeTaksitDetaylari.forEach((taksit:any) => {
      toplam=toplam+Number(taksit.toplam_faiz)
    })
    return toplam.toFixed(2)
  }

  get taksitToplamFaizIsleyenGun(){
    let toplam:number = 0
    this.odemeTaksitDetaylari.forEach((taksit:any) => {
      toplam = toplam+taksit.faiz_isleyen_gun
    })
    return toplam
  }

  get pesinHarc(){
    let pesinHarc:number = 0
    this.kapakHesabi.duzenlenmisTakipSonrasiKalemler.forEach((kalemler:any) => {
      if (kalemler['harc_turu']==='Vekalet Suret Harcı'){
        pesinHarc = kalemler['tutar']
      }
    })
    return pesinHarc
  }
  get toplamIsleyecekFaiz(){
    let toplam:number = 0.00
    this.odemeTaksitDetaylari.forEach((taksit:any) => {
      toplam=toplam+Number(taksit.isleyen_faiz)
    })
    return toplam.toFixed(2)
  }

  get toplamtaksitMiktari(){
    let toplam:number = 0.00
    this.odemeTaksitDetaylari.forEach((taksit:any) => {
      toplam=toplam+Number(taksit.tutar)
    })
    return toplam.toFixed(2)
  }

  async mounted() {
    if (this.takip && this.takip.id) {
      this.isLoadingEvrakData = true;

      try {
        /*// Takip durumuna göre hangi store kullanılacağına karar ver
        const isAcilmamis = this.takip?.takip_durumu === TakipDurumu.acilmamis;

        // İlgili store'dan borçlu verilerini al
        const borclular = isAcilmamis
          ? this.$store.state.takipEkle?.takipBorclular?.data
          : this.$store.state.takipDetay?.takip?.borclular;

        if (borclular && Array.isArray(borclular) && borclular.length > 0) {
          // Takip durumuna göre ilgili store'un action'ını çağır
          const storeName = isAcilmamis ? 'takipEkle' : 'takipDetay';
          await this.$store.dispatch(`${storeName}/loadBorcluVekillerVeTebligatlar`, borclular);

          // State'deki güncel borçlu verilerini takip objesine merge et
          this.mergeBorcluDataFromState();
        }*/

        // Tüm hesaplamaları yap
        this.generateTtEvrak();
        this.calculateKapakHesabi();
        await this.handleTaksitler();
      } catch (error) {
        console.error('Ödeme taahhüdü verileri yüklenirken hata oluştu:', error);
      } finally {
        this.isLoadingEvrakData = false;
      }
    }
  }

  /*mergeBorcluDataFromState() {
    // Takip durumuna göre hangi store'dan veri çekileceğine karar ver
    const isAcilmamis = this.takip?.takip_durumu === TakipDurumu.acilmamis;

    // İlgili store'dan güncellenmiş borçlu verilerini al
    const stateBorclular = isAcilmamis
      ? this.$store.state.takipEkle?.takipBorclular?.data
      : this.$store.state.takipDetay?.takip?.borclular;

    if (!stateBorclular || !this.takip?.borclular) return;

    this.takip.borclular.forEach((takipBorclu: any) => {
      const stateBorclu = stateBorclular.find((sb: any) => sb.id === takipBorclu.id);
      if (stateBorclu) {
        // State'deki yeni field'ları takip objesindeki borçluya ekle
        takipBorclu.vekiller = stateBorclu.vekiller || [];
        takipBorclu.tebligatlar = stateBorclu.tebligatlar || [];
        takipBorclu.borclu_bilgileri = stateBorclu.borclu_bilgileri || null;
        takipBorclu.adresler = stateBorclu.adresler || [];
        takipBorclu.varsayilan_adres = stateBorclu.varsayilan_adres || null;
      }
    });
  }*/

  generateTtEvrak() {
    if (this.takip && this.takip.id) {
      try {
        this.isInternalUpdate = true;

        // Borçlular için eksik alanları kontrol et ve varsayılan değerler ekle
        if (this.takip.borclular && this.takip.borclular.length > 0) {
          this.takip.borclular.forEach((borclu: any) => {
            // borclu_bilgileri yoksa boş obje oluştur
            if (!borclu.borclu_bilgileri) {
              borclu.borclu_bilgileri = {
                yabanci_uyruklu_mu: false,
                tebligat_adresi: null,
                vekiller: [],
                adresler: []
              };
            }
            // yabanci_uyruklu_mu yoksa false yap
            if (borclu.borclu_bilgileri.yabanci_uyruklu_mu === undefined) {
              borclu.borclu_bilgileri.yabanci_uyruklu_mu = false;
            }
          });
        }

        let takipTalebiGenerator = new TakipTalebiGenerator()
        takipTalebiGenerator.setTakip(this.takip);
        this.ttEvrak = takipTalebiGenerator.getTakipTalebiEvrak();

      } catch (error) {
        console.error('TakipTalebiGenerator hatası:', error);
        // Hata durumunda en azından temel bilgileri set et
        this.ttEvrak.icraDairesi = this.takip.icra_dairesi?.isim || '';
        this.ttEvrak.dosyaEsasNo = this.takip.dosya_no || '';
        this.ttEvrak.kartNo = this.takip.id?.toString() || '';
      } finally {
        // Reset flag after mutations complete
        this.$nextTick(() => {
          this.isInternalUpdate = false;
        });
      }
    }
  }

  get dovizTahsilatlar(){
    let tahsilatlar :any = []
    let dovizToplami:number = 0

    this.takip.tahsilatlar.forEach(tah =>{
      tahsilatlar.push(tah)
    })
    tahsilatlar = tahsilatlar.filter((tah:any) => tah.para_birimi_id !== ParaBirimi.TRY);

    tahsilatlar.forEach((doviz:any) => {
      dovizToplami += doviz.tutar * doviz.kur;
    });
    return dovizToplami;
  }

  get tahsilHarcOrani(){
    let tahsilHarcOrani:any
    this.takip.talepler[0].alacaklar.forEach((alacak) => {
      alacak.alacak_kalemleri.forEach((kalemler) => {
        if (kalemler.harc_turu_id === this.harcTuru.tahsil_harci) {
          tahsilHarcOrani=kalemler.harc_orani;
        }
      })
    })
    if (tahsilHarcOrani==null){
      tahsilHarcOrani = "4.55"
    }
    return tahsilHarcOrani

  }

  get cezaEviHarci(){
    let tahsilatlar:any = []

    this.takip.tahsilatlar.forEach((tahsilat:any)=>{
      tahsilatlar ={"cezaevi_harci":tahsilat.cezaevi_harci,
        "tahsilat_turu": tahsilat.tahsilat_turu}
    })
    return tahsilatlar
  }

  calculateKapakHesabi() {
    if (this.takip.id) {
      let kapakHesabiCalculator: KapakHesabiCalculator = new KapakHesabiCalculator();
      kapakHesabiCalculator.setTakip(this.takip);
      this.kapakHesabi = kapakHesabiCalculator.calculateKapakHesabi();
      this.kapakHesabi.alacakKalemiAlanlari.sort(function (a, b) {
        return a - b;
      });
      this.kapakHesabi.takipSonrasialacakKalemiAlanlari.sort(function (a, b) {
        return a - b;
      });
    }
  }

  @Watch("takip", { deep: true })
  onTakipChange() {
    // Prevent infinite loop from internal updates
    if (this.isInternalUpdate) {
      return;
    }

    if (this.takip && this.takip.id) {
      this.generateTtEvrak();
    }
  }

  print() {
    this.$helper.printComponent('odemeTaahhuduTaslak');
  }

  imzasizUdfIndir(){
    this.$helper.getUdfFromComponent("odemeTaahhuduTaslak",true,this.takip.id + "_odemeTaahhuduTaslak");
  }

  imzaliUdfIndir(){
    this.$helper.getImzaliUdfFromComponent("odemeTaahhuduTaslak",true,this.takip.id + "_imzali_odemeTaahhuduTaslak");
  }

}
